import { yupResolver } from '@hookform/resolvers/yup'
import { useForm } from 'react-hook-form'
import * as yup from 'yup'

import {
  ArtistFormField,
  ArtistFormProps,
  FormInputs,
} from './ArtistFormStep.types'

const schema = yup
  .object()
  .shape({
    email: yup
      .string()
      .min(2, "This field must be at least 2 characters long")
      .email('Please enter a valid email address')
      .required('Please enter your email address'),
    name: yup.string().max(64).required('Please enter your name'),
    country: yup.string().required('Please enter your country of residence'),
    location: yup.string().min(2).required('Please enter your location'),
    instagram: yup
      .string()
      .min(2)
      .required('Please enter your instagram username (e.g. @inckd)'),
  })
  .required()

const useArtistForm = ({ questions }: ArtistFormProps) => {
  const defaultValues: Record<ArtistFormField, string | undefined> = {
    name: questions.name.defaultValue,
    email: questions.email.defaultValue,
    country: questions.country.defaultValue,
    location: questions.location.defaultValue,
    instagram: questions.instagram.defaultValue,
  }

  const { handleSubmit, control, formState } = useForm<FormInputs>({
    resolver: yupResolver(schema),
    mode: 'onBlur',
    delayError: 1 * 1000,
    defaultValues,
  })

  return {
    handleSubmit,
    control,
    formState
  }
}

export default useArtistForm
